import type { ComponentProps } from "react"
import DropdownMenu from "@/v2-ui/dropdownMenu"
import cn from "@/v2-ui/utils/utils.cn"

export type ActionMenuSeparatorProps = ComponentProps<
  typeof DropdownMenu.Separator
>

function ActionMenuSeparator(props: ActionMenuSeparatorProps) {
  const { className, ...rest } = props
  return (
    <DropdownMenu.Separator
      className={cn("action-menu-separator", className)}
      {...rest}
    />
  )
}

export default ActionMenuSeparator
